import React from 'react'
import preloader from './../../assets/preloader.gif';

const CustomLoader = () => {
  return (
    <div className="text-center">
        <img src={preloader} alt='Loading...' />
    </div>
  )
}

export default CustomLoader